import { EventSubPageTitle } from '../breadcrumbs/EventSubPageTitle';

export const EventSessionListPageNav = (): React.ReactElement<any, any> | null => {
    return <EventSubPageTitle>Sessions</EventSubPageTitle>;
};
